import { render } from "./BreadcrumbComponent.vue?vue&type=template&id=234d382d&scoped=true"
import script from "./BreadcrumbComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbComponent.vue?vue&type=script&lang=js"

import "./BreadcrumbComponent.vue?vue&type=style&index=0&id=234d382d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234d382d"]])

export default __exports__